import { css } from '@emotion/css';

export const emptyStateStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 24px',
  textAlign: 'center',
  color: 'var(--streamlain-text-secondary-color)',
});

export const emptyStateTitleStyle = css({
  fontSize: '14px',
  fontWeight: 600,
  color: 'var(--streamlain-text-primary-color)',
});

export const emptyStateHintStyle = css({
  fontSize: '13px',
  maxWidth: '320px',
});

export const emptyStateCtaStyle = css({
  appearance: 'none',
  border: '1px solid var(--streamlain-border-color)',
  padding: '6px 14px',
  borderRadius: '4px',
  fontSize: '13px',
  cursor: 'pointer',

  // `&&&` → (0,3,0) beats the blue-white viewport override (0,2,1).
  '&&&': {
    background: 'var(--streamlain-v2-button-primary)',
    color: 'var(--streamlain-v2-button-pureWhiteText)',
  },

  '&:hover': {
    filter: 'brightness(1.05)',
  },
});

export const validationIconStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  background: 'var(--streamlain-error-color)',
  color: 'var(--streamlain-white)',
  fontSize: '11px',
  fontWeight: 700,
  cursor: 'help',
});
